export default __webpack_public_path__ + "45251f7a4b7a8a600354e92e60bc472f.png";